import React, {useEffect, useLayoutEffect, useRef, useState} from "react";
import {ToastContainer} from "react-toastify";

const containerClassNames = {
  error: "bg-red-400",
  default: "bg-green-500",
}
const buttonClassNames = {
  error: "text-red-700",
  default: "text-green-700",
};

export default function Alert () {
    return (
      <ToastContainer
        position="top-center"
        autoClose={3000}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnHover
        hideProgressBar
        draggable
        className="fixed top-5 z-60"
        toastClassName={({ type }) => {
          const className = (containerClassNames[type || "default"] || containerClassNames['default']);

            return className + " rounded-lg px-4 py-2 mx-auto mt-3 md:mt-0 w-11/12 md:w-max shadow-xl flex flex-row justify-between overflow-hidden cursor-pointer mb-2"
        }}
        bodyClassName={({type}) => "text-white font-semibold"}
        closeButton={({type, closeToast}) => {
            const className = (buttonClassNames[type || "default"] || buttonClassNames['default']);

            return <button className={`${className} ml-2`} onClick={closeToast}><i className="fas fa-times fa-fw"></i></button>;
        }}
      />
    )
}
